<template>
  <header aria-label="App menu">
    <a class="iw-visuallyhidden main_content_btn" href="#main_content">Skip to main content</a>
    <div class="theme-group-1 header">
      <div class="header__container">
        <div class="header__logo">
          <app-link
            class="header__link"
            :route-to="{ name: seatRequired ? ROUTE_NAMES.VENUE_CONTAINER : ROUTE_NAMES.VENDOR_PICKER }"
          >
            <img v-image-fall-back="imageFallback" :src="venueIcon" alt="venue home logo" />
          </app-link>
        </div>
        <navigation-bar />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import NavigationBar from "./navigation-bar/NavigationBar";
import { ROUTE_NAMES } from "@/utils";
import DEFAULT_VENUE_ICON from "./../../assets/images/spoton-logo.png";

export default {
  name: "AppHeader",
  components: { NavigationBar },
  data: function () {
    return {
      imageFallback: DEFAULT_VENUE_ICON,
      ROUTE_NAMES
    };
  },
  computed: {
    ...mapGetters({
      venueIcon: "theme/getVenueIcon",
      seatRequired: "venueSettings/seatRequired"
    })
  }
};
</script>

<style scoped lang="scss">
$logo-height: 37px;

.main_content_btn:focus-visible {
  position: unset;
  color: $group-3-color-4;
  margin-left: 10px;
  clip: unset;
  width: unset;
  height: unset;
  text-decoration: none;
}

a:focus + header {
  top: 20px;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: $headerDesktopHeight;
  z-index: 3;

  @include respond-to-mobile {
    height: $headerMobileHeight;
  }

  &__container {
    margin-left: ($spacer * 1.5);
    margin-right: ($spacer * 1.5);
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    @include respond-to-mobile {
      margin-left: $spacer;
      margin-right: $spacer;
    }
  }
  &__link {
    opacity: 1 !important;
    height: $logo-height;
  }
  &__logo {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    img {
      height: $logo-height;
    }
  }
}
</style>
